import { combineReducers } from 'redux';

import dashboardModels from './dashboardModels/dashboardModelsReducer';
import partnerBroker from './partnerBroker/partnerBrokerReducer';

export default combineReducers({
    dashboardModels,
    partnerBroker
});